import { makeStyles } from 'tss-react/mui';
import { colors, spacing } from '../../styles/jss/variables';
export const minHeights = { xs: 336, sm: 208, md: 288, lg: 288, xl: 352 };
const useStyles = makeStyles()((theme, _params, classes) => {
    const isFfOrDeliveryPass = theme.isFlyingFlowers || (_params === null || _params === void 0 ? void 0 : _params.isFromDeliveryPass);
    const contentStyleBreakpoint = isFfOrDeliveryPass ? 'sm' : 'md';
    return {
        container: Object.assign(Object.assign({ display: 'flex', flexDirection: 'column', overflow: 'hidden', [theme.breakpoints.up('sm')]: {
                flexDirection: 'row-reverse',
            }, position: 'relative', backgroundColor: colors.background.BLACK }, (isFfOrDeliveryPass && {
            placeContent: 'center',
        })), { '& div[data-testid="desktopImage"]': {
                width: '100%',
                [theme.breakpoints.up(contentStyleBreakpoint)]: {
                    width: '50%',
                },
            } }),
        heading: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, (!isFfOrDeliveryPass && {
            display: 'flex',
            flexDirection: 'column',
        })), { textAlign: 'left', color: isFfOrDeliveryPass
                ? colors.primary.gold4
                : (_params === null || _params === void 0 ? void 0 : _params.headingColor) && `${colors.genericContentHeading[_params === null || _params === void 0 ? void 0 : _params.headingColor]}` }), theme.typography.large_bold), theme.typographySpacing.large_bold_lg), { [theme.breakpoints.up('md')]: Object.assign(Object.assign({}, theme.typography.large_bold), theme.typographySpacing.large_bold_sm), '& span': {
                marginBottom: 0,
            } }),
        newMessage: Object.assign(Object.assign({}, (!isFfOrDeliveryPass && {
            textAlign: 'left',
        })), { '&': {
                marginBottom: 0,
                paddingTop: 0,
            }, [theme.breakpoints.up('lg')]: Object.assign({}, theme.typography.medium_regular), '& p, & div': Object.assign(Object.assign(Object.assign(Object.assign({}, theme.typography.small_regular), theme.typographySpacing.small_bold_lg), (isFfOrDeliveryPass && {
                color: colors.supplementary.white,
            })), { marginBottom: spacing.small }) }),
        linkContainer: {
            width: '100%',
        },
        contentContainer: {
            [theme.breakpoints.down(contentStyleBreakpoint)]: {
                position: 'absolute',
                width: '100%',
                height: !isFfOrDeliveryPass ? '100%' : 'inherit',
            },
            [theme.breakpoints.up(contentStyleBreakpoint)]: {
                width: '50%',
                position: isFfOrDeliveryPass ? 'relative' : 'absolute',
                left: isFfOrDeliveryPass ? 'unset' : 0,
            },
        },
        innerContentDeliveryPassCard: {
            [theme.breakpoints.up('md')]: Object.assign(Object.assign({}, (isFfOrDeliveryPass && {
                margin: spacing.large,
            })), (!isFfOrDeliveryPass && {
                padding: spacing.large,
            })),
        },
        contentInner: {
            height: '100%',
            padding: 32,
            margin: 0,
            marginBottom: '0px !important',
            [theme.breakpoints.up('md')]: {
                padding: 48,
                margin: 0,
            },
        },
        image: Object.assign(Object.assign(Object.assign(Object.assign({}, (isFfOrDeliveryPass && {
            paddingTop: '100%',
        })), { minHeight: '200px ' }), (!isFfOrDeliveryPass && {
            minHeight: minHeights.xs,
            [`&, & .${classes.image}`]: {
                [theme.breakpoints.up('sm')]: {
                    minHeight: minHeights.sm,
                },
                [theme.breakpoints.up('md')]: {
                    minHeight: minHeights.md,
                },
                [theme.breakpoints.up('lg')]: {
                    minHeight: minHeights.lg,
                },
                [theme.breakpoints.up('xl')]: {
                    minHeight: minHeights.xl,
                },
            },
        })), { [theme.breakpoints.up('xs')]: {
                paddingTop: 0,
            }, '& img': {
                objectFit: 'cover',
            } }),
        positionTop: {
            alignContent: 'flex-start',
        },
        positionCenter: {
            alignContent: 'center',
        },
        positionBottom: {
            alignContent: 'flex-end',
        },
    };
});
export default useStyles;
